import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastController, Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';


export interface TradePayload {
  symbol: string;
  buy: number;
  sell: number;
  modifybuy: number;
  modifysell: number;
  quantity: number;
  TradeType: 'BUY' | 'SELL' | 'BOTH';
}


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // --- BASE URLS ---

   pythonApiUrl: string = 'https://api.balajiholding.tech';
  // pythonApiUrl: string = 'http://localhost:5005';

  //pythonApiUrlauto: string = 'https://api.balajiholding.tech/autoload';


  constructor(private httpClient: HttpClient, private _Router: Router, private plt: Platform) {
  }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  private formatUrl(endpoint: string): string {
    if (endpoint.startsWith('http')) {
      try {
        const urlObj = new URL(endpoint);
        endpoint = urlObj.pathname + urlObj.search; // Extracts just '/submit-trade'
      } catch (e) {}
    }
    // Remove leading slash to prevent double slashes (e.g., https://api.t.tech//submit-trade)
    endpoint = endpoint.replace(/^\/+/, '');
    return `${this.pythonApiUrl}/${endpoint}`;
  }

  // Add this to your api.service.ts file
  getData(endpoint: string, params?: any, reqOpts?: any) {
    
    
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams() // Make sure you have imported HttpParams from @angular/common/http
      };
    }
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    return this.httpClient.get(`${this.pythonApiUrl}/${endpoint}`, reqOpts);
  }


  getExternalApiData(externalUrl: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = { params: new HttpParams() };
    }
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    // Calls the raw externalUrl exactly as provided
    return this.httpClient.get(externalUrl, reqOpts); 
  }

  // getStockdata(endpoint: string, params?: any, reqOpts?: any) {
  //   if (!reqOpts) {
  //     reqOpts = {
  //       params: new HttpParams()
  //     };
  //   }
  //   if (params) {
  //     reqOpts.params = new HttpParams();
  //     for (let k in params) {
  //       reqOpts.params = reqOpts.params.set(k, params[k]);
  //     }
  //   }
  //   return this.httpClient.get(endpoint, reqOpts);
  // }

  // In api.service.ts
  
  getStockdata(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.httpClient.get(`${this.pythonApiUrl}/${endpoint}`, reqOpts);
  }

  getlocal(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    return this.httpClient.get(endpoint, reqOpts);
  }

  
  // --- Stock CRUD Operations ---
  getAllData(): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/getsharelist`);
  }

  addNewData(Data: any): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/insertshare/${Data[0]}/${Data[1]}/${Data[2]}/${Data[3]}`);
  }

  deleteData(Data: any): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/deletestock/${Data[1]}`);
  }

  updateData(id: any, Data: any) {
    return this.httpClient.get(`${this.pythonApiUrl}/updateshare/${Data[0]}/${Data[1]}/${Data[2]}/${Data[3]}`);
  }

  deleteAllScannerData(): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/deleteb`);
  }

  refreshFo(): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/refreshfo`);
  }

  clearCryptoArbitrage(): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/clearcryptoarbitrage`);
  }

  clearRatioSpread(): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/clearratiospread`);
  }

  // --- Python Service Calls ---
  // Changed this to use the pythonApiUrl automatically
  postData(endpoint: string, data: any) {
    return this.httpClient.post(`${this.pythonApiUrl}/${endpoint}`, data);
  }

  // --- Device Management ---
  getDevices(): Observable<any> {
    return this.httpClient.get(`${this.pythonApiUrl}/api/devices`); 
  }

  removeDevice(deviceUuid: string): Observable<any> {
    return this.httpClient.delete(`${this.pythonApiUrl}/api/devices/${deviceUuid}`);
  }

  getExternalData(url: string): Observable<any> {
    return this.httpClient.get(url);
  }

  setFyersAccessToken(accessToken: string): Observable<any> {
    return this.postData('api/set-access-token', { access_token: accessToken });
  }

  submitTrade(tradeData: TradePayload): Observable<any> {
    return this.postData('Auto_server/api/submit-trade', tradeData);
  }
  getLiveTrades(): Observable<any> {
    return this.getData('Auto_server/api/trades');
  }
  startEngine(): Observable<any> {
    return this.postData('Auto_server/api/start-engine', {});
  }
  stopEngine(): Observable<any> {
    return this.postData('Auto_server/api/stop-engine', {});
  }

  submitChaserTrade(payload: any): Observable<any> {
    return this.postData('Auto_server/submit-chaser', payload); 
  }
}